import { render, staticRenderFns } from "./DialogChangePhone.vue?vue&type=template&id=58bc3606&scoped=true&"
import script from "./DialogChangePhone.vue?vue&type=script&lang=js&"
export * from "./DialogChangePhone.vue?vue&type=script&lang=js&"
import style0 from "./DialogChangePhone.vue?vue&type=style&index=0&id=58bc3606&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58bc3606",
  null
  
)

export default component.exports